import React from 'react';
import { Card } from 'semantic-ui-react';
import { arrayOf, string, shape, func, bool } from 'prop-types';

import StationDescription from './StationDescription';
import StationLinks from './StationLinks';

const StationItem = ({
  terms,
  station,
  playStation,
  pauseStation,
  isPlaying,
  match,
  showModal
}) => {
  const { name, logo, website } = station;
  return (
    <Card
      header={name}
      image={`https://www.twr360.org/images/sized/${logo}/c290x290/thumb.jpg?p=files/library`}
      description={
        <StationDescription
          terms={terms}
          station={station}
          match={match}
          showModal={showModal}
        />
      }
      extra={
        <StationLinks
          terms={terms}
          station={station}
          playStation={playStation}
          pauseStation={pauseStation}
          website={website}
          isPlaying={isPlaying}
        />
      }
    />
  );
};

StationItem.propTypes = {
  terms: arrayOf(string).isRequired,
  station: shape().isRequired,
  playStation: func.isRequired,
  pauseStation: func.isRequired,
  isPlaying: bool.isRequired,
  match: shape().isRequired,
  showModal: func.isRequired
};

export default StationItem;
